export const TaskPageEnums = {
    ALL: 0,
    MY_PROJECT_TASK: 1,
    PROJECT_PLANNED_TASK: 2,
    MY_TEAM_TASK: 3,
    TEAM_PLANNED_TASK: 4,
    BACKLOG_TASK: 5,
    ALL_PROJECT_TASK: 6,
};